import { ReactComponent as HefringShield } from "assets/hefring-shield.svg";
import { useTranslation } from "react-i18next";
import { LanguageSelection } from "screens/settings/components/language-selection";
import { useState } from "react";
import { Spinner } from "components/ui/spinner";

export default function AppFirmwareUpdate() {
  const { t } = useTranslation();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [updateApiResult, setUpdateApiResult] = useState("");
  const [updateApiErrorMsg, setUpdateApiErrorMsg] = useState("");

  const apiUrl = `http://${window.location.hostname}:5005/upload-firmware`;

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsSubmitted(true);

    const form = event.target as HTMLFormElement;
    const formData = new FormData(form);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      setUpdateApiResult(await response.text());
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      setUpdateApiErrorMsg(String(error));
    }
  };

  return (
    <section className="h-screen flex flex-col overflow-hidden overflow-y-auto">
      <div className="px-4 sm:px-6 w-full py-6 flex flex-col sm:flex-row sm:items-center justify-between">
        <span className="flex items-center space-x-2">
          <HefringShield className="h-9" />
          <h2 className="text-2xl lg:text-3xl font-medium">
            {t("firmware_update.title")}
          </h2>
        </span>
        <LanguageSelection />
      </div>
      <div className="flex-1 overflow-auto flex flex-col md:flex-row">
        <div className="flex flex-col items-center justify-center w-full p-4">
          {!isSubmitted ? (
            <div>
              <p className="text-primary-200 text-center mb-4 max-w-lg">
                {t("firmware_update.description")}
              </p>
              <form
                action={apiUrl}
                method="post"
                encType="multipart/form-data"
                className="flex flex-col items-center space-y-4"
                onSubmit={handleSubmit}
              >
                <input
                  type="file"
                  name="file"
                  accept=".zip"
                  className="border border-gray-300 p-2 rounded"
                  required
                />
                <button
                  type="submit"
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                  {t("firmware_update.submit_button")}
                </button>
              </form>
            </div>
          ) : (
            <div className="flex flex-col items-center space-y-4">
              {updateApiErrorMsg ? (
                <p className="text-red-500 text-center mb-4 max-w-lg text-lg">
                  <div>{t("firmware_update.failed_message")}</div>
                  <div>{updateApiErrorMsg}</div>
                </p>
              ) : updateApiResult ? (
                <>
                  <p className="text-center mb-4 max-w-lg text-lg">
                    {updateApiResult}
                  </p>
                  <button
                    onClick={() => setIsSubmitted(false)}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                  >
                    {t("firmware_update.submit_another_button")}
                  </button>
                </>
              ) : (
                <>
                  <Spinner />
                  <p className="text-gray-400 text-center mb-4 max-w-lg text-lg">
                    {t("firmware_update.submitted_message")}
                  </p>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
